import { render, staticRenderFns } from "./FormWrapper.vue?vue&type=template&id=ed5ec752&scoped=true"
import script from "./FormWrapper.vue?vue&type=script&lang=js"
export * from "./FormWrapper.vue?vue&type=script&lang=js"
import style0 from "./FormWrapper.vue?vue&type=style&index=0&id=ed5ec752&prod&scoped=true&lang=css"
import style1 from "./FormWrapper.vue?vue&type=style&index=1&id=ed5ec752&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed5ec752",
  null
  
)

export default component.exports